export default __webpack_public_path__ + "static/media/conference-user.e883562c.svg";